import {
	isCustomApiError,
	type PostRegistrationUserPayload,
	safeRequest,
	sessionAtom,
	useIntl
} from '@capsicum/common';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { showEmailInputFormAtom } from '../atoms';
import { postRegistration } from '../data-access';

export const useRegistrationSubmit = () => {
	const { $t } = useIntl();
	const setShowEmailInput = useSetAtom(showEmailInputFormAtom);
	const setSessionRefresh = useSetAtom(sessionAtom);

	return useCallback(
		async (
			registrationParams: PostRegistrationUserPayload
		): Promise<{ field?: string; message?: string; type?: string; userId: string } | undefined> => {
			// TODO remove this log statement once register is done
			const { data, error, success } = await safeRequest(() => postRegistration(registrationParams));

			if (success && !error && !(data instanceof Error)) {
				// TODO: Implement something as below, when we were sending correct requests
				data?.sessionId && setSessionRefresh({ ...data, deviceUid: registrationParams.deviceUid as string });
				setShowEmailInput(true);

				return { userId: data?.userId || '' };
			}

			const errorMessage = isCustomApiError(data) ? data.errors?.[0]?.title : $t('global.error');

			return {
				field: 'submit',
				/**
				 * @todo - Create a util to properly extract the errors
				 */
				message: errorMessage,
				type: 'api',
				userId: data?.userId || ''
			};
		},
		[$t, setSessionRefresh, setShowEmailInput]
	);
};
